module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/profits-disabled.68f0c49c.svg";